<template>
  <div class="minesweeper">
    <div class="row">
      <div>{{ Math.max(0, config.mines - flagCount) }}</div>
      <Clock :startedAt="startedAt" ref="clock" />
    </div>
    <div class="row"><Board :userMap="userMap" :map="map" :config="config" @open="open" @flag="flag" /></div>
    <UiButton @click="start()">Restart</UiButton>
  </div>
</template>

<script>
import {nextTick} from 'vue'
import Board from '@/components/Board.vue'
import Clock from '@/components/Clock'
import UiButton from '@/components/UiButton'

export default {
  name: 'App',
  components: {UiButton, Board, Clock},
  data: () => ({
    map: null,
    userMap: null,
    config: {
      width: 9,
      height: 9,
      mines: 10,
    },
    firstTime: true,
    startedAt: 0,
    readonly: false,
  }),
  computed: {
    flagCount() {
      let res = 0;
      for (let row of this.userMap) {
        for (let cell of row) {
          if (cell === -2) res++;
        }
      }
      return res;
    }
  },
  methods: {
    start() {
      this.generateMap()
      this.startedAt = Date.now()
      this.firstTime = true
      this.readonly = false
      nextTick().then(() => this.$refs.clock.resume())
    },
    adjacentOf(i, j) {
      return [
        [i + 1, j],
        [i + 1, j + 1],
        [i, j + 1],
        [i - 1, j + 1],
        [i - 1, j],
        [i - 1, j - 1],
        [i, j - 1],
        [i + 1, j - 1],
      ].filter(([i, j]) =>
        0 <= i && i < this.config.height
        && 0 <= j && j < this.config.width
      )
    },
    generateMap() {
      this.userMap = []
      for (let i = 0; i < this.config.height; i++) {
        this.userMap[i] = []
        for (let j = 0; j < this.config.width; j++) {
          this.userMap[i][j] = null;
        }
      }
      this.map = []
      for (let i = 0; i < this.config.height; i++) {
        this.map[i] = []
        for (let j = 0; j < this.config.width; j++) {
          this.map[i][j] = 0
        }
      }

      let i = this.config.mines
      while (i) {
        let row = Math.random() * this.config.height | 0
        let col = Math.random() * this.config.width | 0
        if (this.map[row][col] !== -1) {
          this.map[row][col] = -1
          i--
          for (let [i, j] of this.adjacentOf(row, col)) {
            if (this.map[i][j] !== -1)
              this.map[i][j]++
          }
        }
      }
    },
    open([i, j], lastZero = false) {
      if (this.readonly) return
      if (this.firstTime) while (this.map[i][j] !== 0) this.generateMap()
      this.firstTime = false

      if (this.userMap[i][j] === -2 && !lastZero) return
      if (this.userMap[i][j] !== -2 && this.userMap[i][j] !== null) return

      if (this.map[i][j] === -1) return this.gameOver(false)
      this.userMap[i][j] = this.map[i][j]
      if (this.allOpen()) return this.gameOver(true)

      if (this.map[i][j] === 0) {
        this.adjacentOf(i, j).forEach((pos) => this.open(pos, true))
      }
    },
    flag([i, j]) {
      if (this.readonly) return
      if (this.userMap[i][j] === -2) {
        this.userMap[i][j] = null
      } else if (this.userMap[i][j] === null) {
        this.userMap[i][j] = -2
      }
    },
    allOpen() {
      let res = true
      for (let i = 0; i < this.config.height; i++) {
        for (let j = 0; j < this.config.width; j++) {
          if (this.map[i][j] !== -1 && this.userMap[i][j] === null)
            res = false
        }
      }
      return res
    },
    /** @param {Boolean} win */
    gameOver(win) {
      if (win) {
        setTimeout(() => alert(`Victory in ${this.$refs.clock.getDisplay()} seconds.`), 20)
      } else {
        for (let i = 0; i < this.config.height; i++) {
          for (let j = 0; j < this.config.width; j++) {
            if (this.map[i][j] === -1) {
              this.userMap[i][j] = -1
            }
          }
        }
      }
      this.readonly = true
      this.$refs.clock.stop()
    }
  },
  created() {
    this.start()
  }
}
</script>

<style scoped>
.minesweeper {
  display: inline-grid;
  padding: 1em;
  font-family: ui-sans, sans-serif;
}
.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}
</style>
